import React from 'react';
import { X } from 'lucide-react';
import './dbtDetailsModal.scss';

const DetailsModal = ({ detailRow, closeDetail, clusterName, loading = false }) => {
  // detailRow is an array of part objects from API
  // {part_no, part_desc, cluster}

  return (
    <div className="dbt-detail-modal-wrapper">
      <div className="dbt-modal-overlay" role="dialog" aria-modal="true">
        <div className="dbt-modal" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
          <div className="dbt-modal-header">
            <h3 className="dbt-modal-title">
              Cluster Parts Details {clusterName && `- ${clusterName}`}
            </h3>
            <button className="dbt-modal-close" aria-label="Close" onClick={closeDetail}>
              <X size={18} />
            </button>
          </div>

          <div className="dbt-modal-body">
            {loading ? (
              <div style={{ textAlign: 'center', padding: '2rem' }}>
                Loading cluster parts...
              </div>
            ) : detailRow && detailRow.length > 0 ? (
              detailRow.map((part) => (
                <div
                  key={part.id}
                  className="dbt-detail-grid cluster-item"
                  style={{ marginBottom: '1.5rem', paddingBottom: '1rem', borderBottom: '1px solid #ccc' }}
                >
                  <div className="detail-item">
                    <span className="label">Cluster Name</span>
                    <span className="value">{part.name || '—'}</span>
                  </div>
                  <div className="detail-item">
                    <span className="label">Part Number</span>
                    <span className="value">{part.part_number || '—'}</span>
                  </div>
                  <div className="detail-item">
                    <span className="label">Part Description</span>
                    <span className="value">{part.description || '—'}</span>
                  </div>
                </div>
              ))
            ) : (
              <div style={{ textAlign: 'center', padding: '2rem' }}>
                No parts found for this cluster
              </div>
            )}
          </div>

          <div className="dbt-modal-footer">
            <button className="dbt-primary" onClick={closeDetail}>Close</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsModal;
